import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralMethods } from '../globalClass/general-methods';
import { VariablesService } from '../globalService/variables.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GenericResult } from '../globalClass/generic-class.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralHttpService {
  private rootURL = "";
  listGenereal: any[];
  objectGeneral: any;

  constructor(
    private jwtHelper: JwtHelperService,
    private httpClient: HttpClient,
    private generalMethods: GeneralMethods,
    private variableService: VariablesService) {
    this.variableService.getVariables().then(r => { this.rootURL = this.variableService.data.urlApi; });
  }

  expiredToken() {
    var token = sessionStorage.getItem("jwt");
    return this.jwtHelper.isTokenExpired(token);
  }

  // async getHttp<T>(rutaApi: string) {
  //   if(this.expiredToken()){
  //     await this.refresToken().then(
  //       (r:GenericResult) =>{
  //         if(r.error){
  //           this.removeItem();
  //           this._toastr.error('Se ha detectado una violación de seguridad su sesion sera cerrada para validar su identidad. Disculpe las molestias.');
  //           this.router.navigate(["login"]);  
  //         }else{
  //           this.generateToken(r.result)
  //         }
  //       }
  //     )
  //   }else{
  //     return new Promise((resolve, reject) => {
  //       if (this.rootURL == '') {
  //         this.variableService.getVariables().then(r => {
  //           this.rootURL = this.variableService.data.urlApi;
  //           resolve(this.httpClient.get(this.rootURL + rutaApi, { headers: this.generalMethods.getHeader() }).toPromise());
  //         });
  //       } else {
  //         resolve(this.httpClient.get(this.rootURL + rutaApi, { headers: this.generalMethods.getHeader() }).toPromise());
  //       }
  //       error => reject(error);
  //     });
  //   }
  // }

  async getHttp<T>(rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.get(this.rootURL + rutaApi, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.get(this.rootURL + rutaApi, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async postHttp(formData: any, rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.post(this.rootURL + rutaApi, formData, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.post(this.rootURL + rutaApi, formData, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async getHttpById<T>(id: any, rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.get(this.rootURL + rutaApi + '/' + id, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.get(this.rootURL + rutaApi + '/' + id, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }


  async getHttpByIdWithResponseType<T>(id: any, rutaApi: string, type: any) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.get(this.rootURL + rutaApi + '/' + id, { headers: header, responseType: "blob" as "json" }).toPromise());
        });
      } else {
        resolve(this.httpClient.get(this.rootURL + rutaApi + '/' + id, { headers: header, responseType: "blob" as "json" }).toPromise());
      }
      error => reject(error);
    });
  }

  async putHttp<T>(formData: T, id: any, rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.put(this.rootURL + rutaApi + '/' + id, formData, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.put(this.rootURL + rutaApi + '/' + id, formData, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async putHttpNotValue(rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.put(this.rootURL + rutaApi, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.put(this.rootURL + rutaApi, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async deleteHttp(id: any, rutaApi: string) {
    let header = await this.generalMethods.getHeader();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.delete(this.rootURL + rutaApi + '/' + id, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.delete(this.rootURL + rutaApi + '/' + id, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async postWithoutToken(data: any, rutaApi: string) {
    let header = await this.generalMethods.getHeaderWithoutToken();
    return new Promise((resolve, reject) => {
      if (this.rootURL == '') {
        this.variableService.getVariables().then(r => {
          this.rootURL = this.variableService.data.urlApi;
          resolve(this.httpClient.post(this.rootURL + rutaApi, data, { headers: header }).toPromise());
        });
      } else {
        resolve(this.httpClient.post(this.rootURL + rutaApi, data, { headers: header }).toPromise());
      }
      error => reject(error);
    });
  }

  async refreshToken(token: string) {
    let temp = { tokenString: token }
    return await this.postWithoutToken(temp, `Login/RefreshToken`);
  }

  removeItem() {
    sessionStorage.removeItem("jwt");
  }

  generateToken(result: GenericResult) {
    let newtoken = result.result;
    let token = newtoken.token;
    sessionStorage.setItem("jwt", token);
  }

  async refresToken() {
    var newToken;
    var token = sessionStorage.getItem("jwt");
    await this.refreshToken(token).then(
      r => {
        newToken = r;
      }
    );
    return newToken;
  }

}
